import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Alert, Spinner } from "react-bootstrap";
import norecordsvg from "../../../../assets/images/norecord.svg";
import Cards from "../../../Reuseable/Cards";
import Tables from "../../../Reuseable/Tables";
import { api } from "../../../../Services/api";
import "react-confirm-alert/src/react-confirm-alert.css";
import {
  setShowAlert,
  setAllTrackings,
  setFetchedAllTrackingsList,
  setFetchedMyTrackingList,
  setStartAllTrekId,
  setStartMyTrekId,
  setMyTrackings,
  setMyTaskSelectedProject,
  setMyTaskView,
} from "../../../../redux/Tracking/actionCreator";
import { ConfirmationBox } from "../../../Reuseable/ConfimationBox";
import TrackingModalView, { CardView } from "../Tracking/style";
import { TrackingView } from "../Tracking/TrackingView";
import { TrackingListHeader } from "../Tracking/TrackingListHeader";
// Date filter state for My Tasks

import { TrackingListColumns } from "../Tracking/TrackingListColumns";
import { NewTracking } from "../NewTracking";
import { Clone } from "../Tracking/Clone";
import NoDataFound from "../Tracking/NoDataFound";
import Dynamicdata from "../../../Reuseable/Select";
import { v4 as uuid } from "uuid";
import moment from "moment";
import { useSessionStorage } from "react-use";
import { useFetch } from "../../../../Hooks/useFetch";
import { key } from "../../../../data/queryKeys";
import { client } from "../../../..";
import { setFilters } from "../../../../redux/Tracking/actionCreator";
import Modal from "react-bootstrap/Modal";

export default function Tracking({ permission, backlogsPermission }) {
  const editPermission = permission.edit;
  const createPermission = permission.create;
  const deletePermission = permission.delete;
  const fetchedAllTrackings = useSelector(
    (state) => state.Tracking.fetchedAllTrackings,
  );
  const fetchedMyTrackings = useSelector(
    (state) => state.Tracking.fetchedMyTrackings,
  );
  const trackingClientId = useSelector(
    (state) => state.Auth.user.trackingclientid,
  );
  let allTrackingsList = useSelector((state) => state.Tracking.allTrackings);
  let myTrackingList = useSelector((state) => state.Tracking.myTrackings);
  const allFlowStatus = useSelector((state) => state.Tracking.allFlowStatus);
  const user = useSelector((state) => state.Auth.user);
  const authToken = useSelector((state) => state.Auth.authToken);
  const filters = useSelector((state) => state.Tracking.filters);
  const startAllTrackingId = useSelector(
    (state) => state.Tracking.startAllTrackingId,
  );
  const [paginationLoading, setPaginationLoading] = useState(false);
  const { data: allMembersRes } = useFetch(
    key.get_all_members,
    `/trackingusers/memberlist/${trackingClientId}`,
    () => {},
    () => {},
    false,
    false,
  );
  let allMembers = allMembersRes?.data ?? [];
  const { data: allTasksTypesRes } = useFetch(
    key.get_all_tasktypes,
    "/trackingtasktype",
    () => {},
    () => {},
    false,
    false,
  );
  let allTaskTypes = allTasksTypesRes?.data ?? [];

  const { data: allProjectWorkflowRes } = useFetch(
    key.get_all_workflow,
    `/trekrworkflow`,
    () => {},
    () => {},
    false,
    false,
  );
  console.log(
    allProjectWorkflowRes,
    "allProjectWorkflowResallProjectWorkflowRes",
  );

  // Fetch task approval data for the current trackingClientId and log the response
  useEffect(() => {
    if (trackingClientId) {
      api
        .get(`/taskapproval/${trackingClientId}`)
        .then((response) => {
          console.log("Task Approval API response:", response);
        })
        .catch((error) => {
          console.error("Task Approval API error:", error);
        });
    }
  }, [trackingClientId]);

  let allWorkFlow = allProjectWorkflowRes?.data?.workflowList ?? [];

  let Work_Flow = Object.keys(allWorkFlow).map((key) => allWorkFlow[key]);

  let allProjectModals = useSelector((state) => state.Tracking.projectModel);

  const [searchValue, setSearchValue] = useState("");
  const [loading, setLoading] = useState(false);
  const [fileLoading, setFileLoading] = useState(false);
  const [showAlertBox, setShowAlertBox] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  // Approval message for Accept/Decline actions
  const [approvalMsg, setApprovalMsg] = useState("");
  const [showView, setShowView] = useState(false);
  console.log("showView", showView);
  const [showFormView, setShowFormView] = useState(false);
  const [trackingItemData, setTrackingItemData] = useSessionStorage(
    "myTaskTrackingData",
    {},
  );
  console.log(trackingItemData, "trackingItemDatatrackingItemData");
  const [deleteConfirmationShow, setDeleteConfirmationShow] = useState(false);
  const [formType, setFormType] = useState("");
  const [clonetaskData, setCloneTask] = useState({});
  const taskview = useSelector((state) => state.Tracking.myTaskView);
  const [filterLoading, setFilterLoading] = useState(false);
  const [allcheckTable, setAllCheckTable] = useState([]);
  const [selectAllTasks, setSelectAllTasks] = useState(false);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  // const getAllUniqueStatuses = (data) => {
  //   const seen = new Set();

  //   for (let key in data) {
  //     const workflows = data[key];

  //     if (!Array.isArray(workflows)) continue;

  //     for (let i = 0; i < workflows.length; i++) {
  //       const wf = workflows[i];

  //       for (let j = 0; j < (wf.workFlow || []).length; j++) {
  //         const item = wf.workFlow[j];

  //         let value = Object.values(item)[0];

  //         if (!value) continue;

  //         value = value.trim().toLowerCase();

  //         if (!value) continue;

  //         seen.add(value);
  //       }
  //     }
  //   }

  //   const result = Array.from(seen).map((status) =>
  //     status
  //       .split(" ")
  //       .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
  //       .join(" "),
  //   );

  //   return result;
  // };

  const getAllUniqueStatuses = (data) => {
    console.log("INPUT DATA:", data);

    const seen = new Set();

    for (let key in data) {
      console.log("KEY:", key);

      const workflows = data[key];
      console.log("WORKFLOWS:", workflows);

      if (!Array.isArray(workflows)) {
        console.log("Skipped (not array):", workflows);
        continue;
      }

      for (let i = 0; i < workflows.length; i++) {
        const wf = workflows[i];
        console.log("Workflow item:", wf);

        for (let j = 0; j < (wf.workFlow || []).length; j++) {
          const item = wf.workFlow[j];
          console.log("WorkFlow entry:", item);

          let value = Object.values(item)[0];
          console.log("Raw value:", value);

          if (!value) {
            console.log("Skipped (empty value)");
            continue;
          }

          value = value.trim().toLowerCase();
          console.log("Formatted value:", value);

          if (!value) {
            console.log("Skipped (empty after trim)");
            continue;
          }

          seen.add(value);
          console.log("Added to set:", value);
        }
      }
    }

    console.log("SET CONTENT:", seen);

    const result = Array.from(seen).map((status) =>
      status
        .split(" ")
        .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
        .join(" "),
    );

    console.log("FINAL RESULT:", result);

    return result;
  };

  const allStatuses = getAllUniqueStatuses(
    allProjectWorkflowRes?.data?.workflowList,
  );

  console.log(allStatuses, "allStatusesallStatusesallStatuses");

  // Date change handlers for My Tasks filter
  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const formatted = moment(dateStr, "YYYY-MM-DD").format("YYYY-MM-DD");
    return formatted === "Invalid date" ? "" : formatted;
  };
  const handleStartDateChange = (date, dateString) => {
    const formattedDate = formatDate(dateString);
    setFromDate(formattedDate);
  };
  const handleToDateChange = (date, dateString) => {
    const formattedDate = formatDate(dateString);
    setToDate(formattedDate);
  };

  const handleTasksHeaderCheckbox = () => {
    if (selectAllTasks) {
      setAllCheckTable([]);
    } else {
      const allRowIndexes = myTrackingList.map((item, index) => ({
        item,
        index,
      }));
      setAllCheckTable(allRowIndexes);
    }
    setSelectAllTasks((prevSelectAll) => !prevSelectAll);
  };

  const handleMoveCheckboxTable = (item, index) => {
    if (allcheckTable.some((row) => row.index === index)) {
      setAllCheckTable((prevSelectedRows) =>
        prevSelectedRows.filter((row) => row.index !== index),
      );
    } else {
      setAllCheckTable((prevSelectedRows) => {
        if (!Array.isArray(prevSelectedRows)) {
          prevSelectedRows = [];
        }
        return [...prevSelectedRows, { item, index }];
      });
    }
  };

  const setTaskview = (view) => {
    dispatch(setMyTaskView(view));
  };

  const handleSearch = (value) => {
    setSearchValue(value);
  };
  const dispatch = useDispatch();

  const [trackingSortings, setTrackingSorting] = useState({
    selectedSortingItem: "trackingid",
    trackingNumberSorting: "down",
    statusSorting: "",
    typeSorting: "",
    projectNameSorting: "",
    reportedBySorting: "",
    prioritySorting: "",
    assignedToSorting: "",
    expectedDeadlineSorting: "",
  });

  const [trackingFilters, setTrackingFilters] = useState({
    projectsFilter: filters?.projects,
    typeFilter: filters?.taskType,
    assignedtoFilter: filters?.assignedTo,
    statusFilter: filters?.status,
    priorityFilter: filters?.priority,
    reportedByFilter: filters?.reportedBy,
  });

  const selected_menu = "my_tasks";
  const [cardui, setCardui] = useSessionStorage("List", "List");
  const [changeInForm, setChangeInForm] = useState(false);
  const [showFilter, setShowFilter] = useState(false);
  const [viewTaskData, setViewTaskData] = useState({});
  const [taskfile, setTaskFile] = useState("");
  const [taskfileList, setTaskFileList] = useState("");
  const [taskfileType, setTaskFileType] = useState("");
  const [showEditTask, setShowEditTask] = useState("");
  const [updatedData, setUpdatedData] = useSessionStorage(
    "myTrackingUpdatedData",
    {},
  );
  const [taskHistory, setHistory] = useState("");
  const [showClone, setShowClone] = useState(false);
  const [startMyTrackingId, setStartMyTrackingId] = useState(
    useSelector((state) => state.Tracking.startMyTrackingId),
  );

  // Add missing ref to prevent duplicate in-flight pagination requests
  const isFetchingRef = useRef(false);

  const [showTaskModal, setShowTaskModal] = useState(false);

  const selectedProject = useSelector(
    (state) => state.Tracking.myTaskSelectedProject,
  );
  const [selectedProjectName, setSelectedProjectName] = useState("");

  useEffect(() => {
    setTimeout(() => {
      dispatch(setShowAlert(false));
      setAlertMessage("");
      setShowAlertBox(false);
    }, 2500);
    setTaskview("AllTask");
  }, []);

  useEffect(() => {
    setTimeout(() => {
      setAlertMessage("");
      setShowAlertBox(false);
    }, 2500);
  }, [showAlertBox]);

  useEffect(() => {
    setViewTaskData((prevState) => {
      return {
        ...prevState,
        title: trackingItemData.title,
        projectid: trackingItemData.trackingprojectsid,
        taskType: trackingItemData.type,
        assignedTo: trackingItemData.assignedto,
        priority: trackingItemData.priority,
        status: trackingItemData.trackingprojectstatusid, // there is not status with ID 0 and 1
        description: trackingItemData.description,
        timeline: trackingItemData.timeline,
        timezone: trackingItemData.timezone,
        fileurls: trackingItemData.fileurls,
        eta: trackingItemData.eta,
        deadline: trackingItemData.deadline,
        approvalaction: trackingItemData.approvalaction,
      };
    });
    setCloneTask((prevState) => {
      return {
        ...prevState,
        title: trackingItemData.cloneTitle,
        assignedto: trackingItemData.assignedto,
        approvalaction: trackingItemData.approvalaction,
      };
    });
    setUpdatedData((prevState) => {
      return {
        ...prevState,
        title: trackingItemData.title,
        description: trackingItemData.description,
        fileurls: trackingItemData.fileurls,
        timeline: trackingItemData.timeline,
        approvalaction: trackingItemData.approvalaction,
      };
    });
  }, [trackingItemData]);

  useEffect(() => {
    if (selected_menu === "my_tasks") {
      setShowFilter(true);
      setTrackingFilters({});
    }
  }, [selected_menu]);

  const refreshAllTracking = () => {
    fetchTrackingsList(project, "refresh");
    setStartMyTrackingId(null);
    dispatch(setStartMyTrekId(null));
    fetchFilteredTasks(true);
  };

  const { data: allProjectsRes, isLoading: allProjectsLoading } = useFetch(
    key.get_all_projects,
    `/trackingprojects/${trackingClientId}`,
    () => {},
    () => {},
    false,
    true,
  );

  const allProjects = allProjectsRes?.data?.Items ?? [];

  const project = selectedProject || allProjects[0]?.trackingprojectid;

  const fetchTrackingsList = (startId, fetchtype) => {
    setLoading(true);

    let url = `/tracking/mytask/${startId === "none" ? null : startId}`;
    api
      .get(url, {
        headers: {
          authorizationtoken: ` ${authToken}`,
          "Access-Control-Allow-Headers": "*",
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "*",
        },
      })
      .then(function (response) {
        if (response.data.status === true) {
          if (selected_menu === "my_tasks") {
            if (response.data.data) {
              if (fetchtype === "refresh")
                dispatch(setMyTrackings([...response.data.data]));
              else {
                if (myTrackingList?.length > 0) {
                  dispatch(setMyTrackings(response.data.data));
                } else dispatch(setMyTrackings(response.data.data));
              }
            }

            // Set LastEvaluatedKey if available
            if (response.data.data.LastEvaluatedKey) {
              setStartMyTrackingId(
                response.data.data.LastEvaluatedKey.trackingid,
              );
              dispatch(
                setStartMyTrekId(
                  response.data.data.LastEvaluatedKey.trackingid,
                ),
              );
            } else {
              setStartMyTrackingId("none");
              dispatch(setStartMyTrekId("none"));
            }
          } else {
            if (response.data.data) {
              if (fetchtype === "refresh")
                dispatch(setAllTrackings([...response.data.data]));
              else {
                if (allTrackingsList?.length > 0) {
                  allTrackingsList = [
                    ...allTrackingsList,
                    ...response.data.data,
                  ];
                  dispatch(setAllTrackings(allTrackingsList));
                } else dispatch(setAllTrackings(response.data.data));
              }
            }

            if (response.data.data.LastEvaluatedKey) {
              dispatch(
                setStartAllTrekId(
                  response.data.data.LastEvaluatedKey.trackingid,
                ),
              );
            } else {
              dispatch(setStartAllTrekId("none"));
            }
            dispatch(setFetchedAllTrackingsList(true));
          }

          setLoading(false);
        }
      })
      .catch((error) => {
        console.error("fetchTrackingsList  error", error);
        setLoading(false);
      });
  };

  // useEffect(() => {
  //   if (project) {
  //     fetchTrackingsList(project)
  //   }
  // }, [project])

  // Set fetchedMyTrackings to true only after myTrackingList is updated (even if empty)
  useEffect(() => {
    if (myTrackingList !== undefined && myTrackingList !== null) {
      dispatch(setFetchedMyTrackingList(true));
    }
    // eslint-disable-next-line
  }, [myTrackingList]);

  let ProjectModoptions = [];
  if (allProjectModals?.length > 0) {
    allProjectModals.forEach((item) =>
      ProjectModoptions.push({
        label: item.ModelTitle,
        id: item.ProjectModelId,
      }),
    );
  }

  let AllProjects = [];
  if (allProjects?.length > 0) {
    allProjects.forEach((element) => {
      AllProjects.push({
        label: element?.label,
        id: element?.trackingprojectid,
      });
    });
  }

  const { data: allInputformsRed } = useFetch(
    key.get_all_inputforms,
    "/masterdata/2",
    () => {},
    () => {},
    false,
    false,
  );
  let allAddTaskInputs = allInputformsRed?.formStructureData ?? [];
  let inputFormArr = useSelector((state) => state.Tracking.inputFormArr);
  console.log(allAddTaskInputs, "allAddTaskInputs");

  const menus = useSelector((state) => state.Auth.menuList);
  const editorRef = useRef(null);

  const changesInList = useRef(null);

  const changesMade = () => {
    changesInList.current = uuid();
  };

  const buildTaskFilterPayload = () => {
    // Use Redux filters or local state
    console.log(
      trackingFilters.projectsFilter?.map((f) => f.value),
      "trackingFiltersffh",
      trackingFilters,
    );

    // Helper to safely extract values and remove null/undefined/empty
    const extractValues = (arr) =>
      Array.isArray(arr)
        ? arr
            .map((f) => f?.value)
            .filter((v) => v !== null && v !== undefined && v !== "")
        : [];

    let assignedtoPayload = extractValues(trackingFilters.assignedtoFilter);
    if (!assignedtoPayload.length) assignedtoPayload = [user?.trackinguserid];

    const projectIds = extractValues(trackingFilters.projectsFilter);

    return {
      // ensure we send [] when no project filter is selected (avoid [null])
      trackingprojectsid: projectIds,
      assignedto: assignedtoPayload,
      tasktype: extractValues(trackingFilters.typeFilter),
      priority: extractValues(trackingFilters.priorityFilter),
      reportedby: extractValues(trackingFilters.reportedByFilter),
      status: [],
      fromDate: fromDate || "",
      toDate: toDate || "",
    };
  };

  // Modified fetchFilteredTasks to support reset (initial) and pagination (append)
  const fetchFilteredTasks = async (reset = true) => {
    if (searchValue) {
      reset = true;
    }
    if (isFetchingRef.current) return;

    if (!reset && (startMyTrackingId === "none" || startMyTrackingId === null))
      return;

    isFetchingRef.current = true;
    if (reset) {
      setFilterLoading(true);
      setLoading(true);
    } else {
      setPaginationLoading(true);
    }

    try {
      const payload = buildTaskFilterPayload();
      console.log("Filter Payload:", payload); // Debug log
      const lastEvalParam = reset ? "null" : startMyTrackingId;
      const resp = await api.post(
        `/tracking/taskfilter?lastEvaluatedKey=${lastEvalParam}&limit=100`,
        payload,
        {
          headers: { authorizationtoken: authToken },
        },
      );

      console.log(resp?.data?.data, "mydata");

      const newData = resp?.data?.data || [];
      const lastEvalKey =
        resp?.data?.LastEvaluatedKey?.trackingid ??
        (resp?.data?.LastEvaluatedKey ? resp?.data?.LastEvaluatedKey : null);

      console.log("API Response - newData:", newData); // Debug log
      console.log("API Response - lastEvalKey:", lastEvalKey); // Debug log

      if (reset) {
        // IMPORTANT: Dispatch to Redux first
        dispatch(setMyTrackings(newData));
        // Then set local state - but this will be recalculated by useEffect
        // setMyTrackingData(getData(newData)) // REMOVE THIS LINE
      } else {
        const existing = Array.isArray(myTrackingList) ? myTrackingList : [];
        const combined = [...existing, ...newData];
        dispatch(setMyTrackings(combined));
        // setMyTrackingData(getData(combined)) // REMOVE THIS LINE
      }

      // Update pagination pointer
      if (lastEvalKey) {
        setStartMyTrackingId(lastEvalKey);
        dispatch(setStartMyTrekId(lastEvalKey));
      } else {
        setStartMyTrackingId("none");
        dispatch(setStartMyTrekId("none"));
      }

      dispatch(setFetchedMyTrackingList(true));
    } catch (err) {
      console.error("fetchFilteredTasks error:", err); // Debug log
      if (reset) {
        // setMyTrackingData([]) // REMOVE THIS LINE
        dispatch(setMyTrackings([]));
        dispatch(setFetchedMyTrackingList(true));
      }
    } finally {
      setFilterLoading(false);
      setLoading(false);
      setPaginationLoading(false); // Add this
      isFetchingRef.current = false;
    }
  };

  // Fetch on mount and when filters/search change
  useEffect(() => {
    fetchFilteredTasks(true);
    // eslint-disable-next-line
  }, [JSON.stringify(trackingFilters), searchValue]);

  // Scroll handler to load more when near bottom
  useEffect(() => {
    const handleScroll = () => {
      // Don't attempt pagination if searching or filterLoading or no more pages
      if (searchValue || filterLoading || isFetchingRef.current) return;
      if (startMyTrackingId === "none" || startMyTrackingId === null) return;

      const threshold = 300; // px from bottom
      const scrolledToBottom =
        window.innerHeight + window.scrollY >=
        document.body.offsetHeight - threshold;
      if (scrolledToBottom) {
        fetchFilteredTasks(false); // append / paginate
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
    // include dependencies relevant to pagination
  }, [startMyTrackingId, searchValue, filterLoading, myTrackingList]);

  const deleteConfimrationHandler = (response) => {
    if (response) {
      api
        .delete(
          "/tracking/" + trackingClientId + "/" + trackingItemData.trackingid,
          {
            headers: {
              authorizationtoken: ` ${authToken}`,
            },
          },
        )
        .then(function (response) {
          if (response.status === 200) {
            changesMade();
            setShowAlertBox(true);
            setTaskview("AllTask");
            let index = myTrackingList.findIndex(
              (element) => element.trackingid === trackingItemData.trackingid,
            );
            if (index >= 0) {
              myTrackingList.splice(index, 1);
            }
            changesMade();
            setAlertMessage("Selected item has been deleted successfully");
          }
        });
    }
  };

  const taskViewRender = (value) => {
    setTaskview(value);
  };

  const refreshfiles = (item) => {
    fetchFileData(item, "refresh");
  };

  const fetchFileData = (item) => {
    for (let i = 0; i < item.fileurls?.length; i++) {
      setFileLoading(true);
      api
        .get(
          `/tracking/fileupload/${trackingClientId}/${item.trackingid}/${item.fileurls[i]}`,
        )
        .then((response) => {
          if (response) {
            let Filename = item.fileurls[i];
            setTaskFile((prevfiles) => [...prevfiles, response.data.url]);
            setTaskFileType((prevfiles) => [
              ...prevfiles,
              Filename.split(".").pop(),
            ]);
            setTaskFileList((prevfiles) => [...prevfiles, Filename]);
            setFileLoading(false);
          } else {
            console.error("Error");
          }
        });
    }
  };

  const getData = (data) => {
    console.log(data, "getdatagetdata");
    let result = data;
    // Frontend filter for priority, reportedby, and status (My Task only)
    console.log(result, "trackingFilters.priorityFilter");
    if (selected_menu === "my_tasks") {
      if (
        trackingFilters?.priorityFilter &&
        trackingFilters?.priorityFilter?.length > 0
      ) {
        const selectedPriorities = trackingFilters?.priorityFilter?.map((f) =>
          f?.value?.toLowerCase()?.trim(),
        );

        const normalizePriority = (p) => {
          if (!p) return "";
          const norm = p.toLowerCase().trim().replace(/\s+/g, "");
          if (
            [
              "blockerlevel1",
              "blocker1",
              "blocker level 1",
              "blocker-level-1",
            ].includes(norm)
          )
            return "blocker1";
          if (
            [
              "blockerlevel2",
              "blocker2",
              "blocker level 2",
              "blocker-level-2",
            ].includes(norm)
          )
            return "blocker2";
          return norm;
        };

        result = result.filter((item) => {
          const itemPriority = normalizePriority(item.priority);
          return selectedPriorities
            .map(normalizePriority)
            .includes(itemPriority);
        });

        console.log(selectedPriorities, "selectedPriorities");
        console.log(result, "resultresult");
      }

      if (
        trackingFilters.reportedByFilter &&
        trackingFilters.reportedByFilter.length > 0
      ) {
        const selectedReportedBy = trackingFilters.reportedByFilter.map(
          (f) => f.value,
        );
        result = result.filter((item) =>
          selectedReportedBy.includes(item.reportedby),
        );
      }
      // Add status filter (frontend)
    }
    result = result
      ?.sort((item1, item2) => {
        if (trackingSortings.selectedSortingItem === "priority") {
          if (trackingSortings.prioritySorting) {
            if (trackingSortings.prioritySorting === "down") {
              if (item1.priority < item2.priority) return 1;
              else return -1;
            } else {
              if (item1.priority < item2.priority) return -1;
              else return 1;
            }
          }
        } else if (trackingSortings.selectedSortingItem === "project") {
          if (trackingSortings.projectNameSorting) {
            if (trackingSortings.projectNameSorting === "down") {
              if (item1.project_name < item2.project_name) return 1;
              else return -1;
            } else {
              if (item1.project_name < item2.project_name) return -1;
              else return 1;
            }
          }
        } else if (trackingSortings.selectedSortingItem === "reportedby") {
          if (trackingSortings.reportedBySorting) {
            if (trackingSortings.reportedBySorting === "down") {
              if (item1.reportedByName < item2.reportedByName) return 1;
              else return -1;
            } else {
              if (item1.reportedByName < item2.reportedByName) return -1;
              else return 1;
            }
          }
        } else if (trackingSortings.selectedSortingItem === "status") {
          if (trackingSortings.statusSorting) {
            if (trackingSortings.statusSorting === "down") {
              if (item1.status_name < item2.status_name) return 1;
              else return -1;
            } else {
              if (item1.status_name < item2.status_name) return -1;
              else return 1;
            }
          } else if (
            trackingSortings.selectedSortingItem === "expectedDeadline"
          ) {
            if (trackingSortings.expectedDeadlineSorting) {
              const d1 = moment(
                item1.expectedDeadline || item1.deadline,
              ).valueOf();
              const d2 = moment(
                item2.expectedDeadline || item2.deadline,
              ).valueOf();
              // Handle empty/null date values — keep them last
              if (!d1) return 1;
              if (!d2) return -1;
              if (trackingSortings.expectedDeadlineSorting === "down") {
                return d1 < d2 ? 1 : -1; // Descending
              } else {
                return d1 < d2 ? -1 : 1; // Ascending
              }
            }
          }
        } else if (trackingSortings.selectedSortingItem === "assignedto") {
          if (trackingSortings.assignedToSorting) {
            if (trackingSortings.assignedToSorting === "down") {
              if (item1.assignedtoName < item2.assignedtoName) return 1;
              else return -1;
            } else {
              if (item1.assignedtoName < item2.assignedtoName) return -1;
              else return 1;
            }
          }
        } else if (trackingSortings.selectedSortingItem === "type") {
          if (trackingSortings.typeSorting) {
            if (trackingSortings.typeSorting === "down") {
              if (item1.taskName < item2.taskName) return 1;
              else return -1;
            } else {
              if (item1.taskName < item2.taskName) return -1;
              else return 1;
            }
          }
        } else {
          if (trackingSortings.trackingNumberSorting) {
            if (trackingSortings.trackingNumberSorting === "down") {
              if (parseInt(item1.trackingid) < parseInt(item2.trackingid))
                return 1;
              else return -1;
            } else {
              if (parseInt(item1.trackingid) < parseInt(item2.trackingid))
                return -1;
              else return 1;
            }
          }
        }
      })

      .filter((item) => {
        let trackingnumber = trackingClientId + "-" + item.trackingid;
        let trackingnumber1 = trackingClientId + item.trackingid;
        return (
          trackingnumber.toLowerCase().includes(searchValue.toLowerCase()) ||
          trackingnumber1.toLowerCase().includes(searchValue.toLowerCase()) ||
          item.title.toLowerCase().includes(searchValue.toLowerCase())
        );
      })
      .map((item, i) => {
        let project_name = allProjects?.find(
          (e) => e?.trackingprojectid === item?.trackingprojectsid,
        );
        if (project_name) {
          item.project_name = project_name.label;
        } else {
          // Fallback: try to find by number as well
          project_name = allProjects?.find(
            (e) => e?.number === item?.trackingprojectsid,
          );
          if (project_name) {
            item.project_name = project_name.label;
          } else {
            item.project_name = "Not Assigned";
          }
        }

        let workflowId = allProjects?.find(
          (e) =>
            e.trackingprojectid == item?.trackingprojectsid ||
            e.number == item?.trackingprojectsid,
        );
        if (workflowId) item.workflowId = workflowId.workflow;

        // Use the same pattern as other components for consistent status mapping
        const Work_Flow = Object.values(
          allProjectWorkflowRes?.data?.workflowList,
        ).flatMap((obj) => Object.values(obj));
        let workflow = Work_Flow.find((e) => e.workFlowId == item.workflowId);
        if (workflow) item.workflow = workflow?.workFlow;

        const statusName =
          item?.workflow && item?.workflow[item.trackingprojectstatusid]
            ? item?.workflow[item.trackingprojectstatusid]
            : "";
        item.status_name = statusName ? Object.values(statusName) : "";
        let reportedByName = allMembers.find(
          (e) => e.userId === item.reportedby,
        );
        if (reportedByName) item.reportedByName = reportedByName.personname;

        let assignedto = allMembers.find((e) => e.userId === item.assignedto);
        if (assignedto) item.assignedtoName = assignedto.personname;
        else item.assignedtoName = "Not Assigned";
        let task = allTaskTypes.find((e) => e.id === item.type);
        if (task) item.taskName = task.label;
        item.cloneTitle = "Clone - " + item.title;

        return item;
      });

    console.log(
      result,
      "resultresultresult",
      trackingFilters.statusFilter,
      result?.status_name === trackingFilters.statusFilter?.label,
    );
    return result.filter((item) => {
      if (
        trackingFilters.statusFilter &&
        trackingFilters.statusFilter.length > 0
      ) {
        console.log(
          "trackingFilters.statusFilter12",
          trackingFilters.statusFilter,
        );
        let filterdData = trackingFilters.statusFilter.filter((element) => {
          console.log("element-->", element.label, item?.status_name?.[0]);
          if (element?.label === "No Status") {
            return item?.status_name?.[0] === undefined;
          } else {
            return element?.label === item?.status_name?.[0];
          }
        });
        if (filterdData.length > 0) return item;
        else return false;
      } else return item;
    });
  };

  // Around line 824, modify the useState initialization:
  const [myTrackingData, setMyTrackingData] = useState(() =>
    getData(myTrackingList || []),
  );

  console.log("myTrackingData1111", myTrackingData);

  // Around line 670, modify the useEffect:
  useEffect(() => {
    // Only fetch if we don't already have data (prevents unnecessary fetch on reload)
    if (!myTrackingList || myTrackingList.length === 0) {
      fetchFilteredTasks(true);
    } else {
      // We have data from Redux persistence, just process it
      setMyTrackingData(getData(myTrackingList));
    }
    // eslint-disable-next-line
  }, []); // Run only once on mount

  // Keep the filter-triggered fetch separate:
  useEffect(() => {
    // Skip the initial render (handled above)
    if (myTrackingList !== undefined) {
      fetchFilteredTasks(true);
    }
    // eslint-disable-next-line
  }, [JSON.stringify(trackingFilters), searchValue]);

  const showWorkFlow = allProjects.find(
    (allProject) => allProject.trackingprojectid === project,
  )?.workflow;
  const workflow = Work_Flow.find((flow) => flow[0].workFlowId == showWorkFlow); // ? Don't Use "===" insted use "==" because it does not check same string or number

  let initialWorkflow = useRef({});

  let WorkFlow =
    workflow &&
    workflow[0]?.workFlow &&
    Object.entries(workflow[0]?.workFlow)?.map(([key, value], index) => {
      return {
        [uuid()]: {
          name: value[key],
          items: [],
          trackingprojectstatusid: index.toString(),
          edit: false,
          loader: false,
        },
      };
    });

  initialWorkflow.current = {};

  WorkFlow?.forEach((element, index) => {
    const [key] = Object.keys(element);
    const [value] = Object.values(element);
    initialWorkflow.current[key] = value;
  });

  const [columns, setColumns] = useState(initialWorkflow.current);
  const [quickTaskLoading, setQuickTaskLoading] = useState(false);

  const includeUuid = (data) => {
    return (
      data &&
      Object.entries(data).map(([k, d]) => {
        return { ...d, id: uuid() };
      })
    );
  };

  const makeCategory = (data) => {
    let uuidData = includeUuid(data);
    let cols = initialWorkflow.current;
    uuidData &&
      Object.entries(uuidData).map(([key, value]) => {
        return Object.entries(cols).map(([k, col]) => {
          if (
            col.name?.toLowerCase() ===
            value.status_name?.toString().toLowerCase()
          ) {
            return col.items.push(value);
          }
          return 0;
        });
      });
    setColumns(cols);
  };

  const handleWorkFlowNameUpdate = (updatedColumns) => {
    let workflowarray = Object.entries(updatedColumns).map(
      ([key, value], index) => {
        return { [index]: value.name };
      },
    );

    const currentWorkFlow = workflow[0];

    const WorkflowObject = {
      workFlowId: currentWorkFlow.workFlowId,
      workFlow: {
        createdBy: currentWorkFlow.createdBy,
        workFlowName: currentWorkFlow.workFlowName,
        createdOn: currentWorkFlow.createdOn,
        updatedOn: new moment().format("DD/MM/YYYY"),
        workFlowId: currentWorkFlow.workFlowId,
        workFlow: workflowarray,
        workflowStatus: currentWorkFlow.workflowStatus,
      },
    };
    api
      .patch("/trekrworkflow", WorkflowObject, {
        headers: {
          authorizationtoken: `${authToken}`,
        },
      })
      .then((response) => {
        client.invalidateQueries({
          queryKey: [key.get_all_workflow],
        });
      })
      .catch((error) => {
        return error;
      });
  };

  const editSwitch = (name, state, updatedName, updateToApi = false) => {
    const newColumns = Object.entries(columns).map(([key, value]) => {
      if (value.name === name) {
        return {
          [uuid()]: { ...value, edit: state, name: updatedName },
        };
      }
      return { [uuid()]: value };
    });

    let updatedColumns = {};

    newColumns.forEach((element, index) => {
      const [key] = Object.keys(element);
      const [value] = Object.values(element);
      updatedColumns[key] = value;
    });

    setColumns(updatedColumns);

    if (updateToApi) {
      handleWorkFlowNameUpdate(updatedColumns);
    }
  };

  const isLoading = (id, ans) => {
    setQuickTaskLoading(ans);
    const newColumns = Object.entries(columns).map(([key, value]) => {
      if (value.trackingprojectstatusid === id) {
        return {
          [uuid()]: { ...value, loader: ans },
        };
      }
      return { [uuid()]: value };
    });

    let updatedColumns = {};

    newColumns.forEach((element, index) => {
      const [key] = Object.keys(element);
      const [value] = Object.values(element);
      updatedColumns[key] = value;
    });

    changesMade();
    setColumns(updatedColumns);
  };

  const handleRowClick = (rowData) => {
    setTrackingItemData(rowData);
    setShowTaskModal(true);
  };

  const handlePopUpclose = () => {
    setTaskview("AllTask");
  };

  useEffect(() => {
    // Don't process data until all required data is loaded
    if (!myTrackingList) return;
    if (!allProjects || allProjects.length === 0) return;
    if (!allMembers || allMembers.length === 0) return;
    if (!allTaskTypes || allTaskTypes.length === 0) return;
    if (!allProjectWorkflowRes?.data?.workflowList) return;

    console.log("Processing myTrackingList:", myTrackingList); // Debug log
    const processedData = getData(myTrackingList);
    console.log("Processed data:", processedData); // Debug log
    setMyTrackingData(processedData);
  }, [
    myTrackingList,
    project,
    changesInList.current,
    workflow,
    searchValue,
    trackingFilters,
    trackingSortings,
    allWorkFlow,
    allProjects,
    allMembers,
    allTaskTypes,
    JSON.stringify(allProjectWorkflowRes?.data?.workflowList),
  ]);

  useEffect(() => {
    const newData = myTrackingData;
    !quickTaskLoading && makeCategory(newData);
  }, [
    myTrackingData,
    project,
    changesInList.current,
    workflow,
    searchValue,
    trackingFilters,
    trackingSortings,
  ]);

  const getSelectedOption = (data, name) => {
    dispatch(setMyTaskSelectedProject(data));
    setSelectedProjectName(name);
  };

  if (taskview === "addnew") {
    return (
      <NewTracking
        setTaskview={setTaskview}
        setShowAlertBox={(val) => setShowAlertBox(val)}
        setAlertMessage={(val) => setAlertMessage(val)}
        refreshAllTracking={refreshAllTracking}
        defaultProjectid={project}
        inputFormArr={allAddTaskInputs}
      />
    );
  }

  if (loading && !fetchedMyTrackings) {
    return (
      <div className="text-center mt-5 mb-5">
        <Spinner animation="border" variant="info" />
      </div>
    );
  }

  if (
    allProjects?.length <= 0 &&
    myTrackingList?.length <= 0 &&
    (!fetchedMyTrackings || !loading)
  ) {
    return allProjectsLoading ? (
      cardui !== "List" && (
        <div className="text-center mt-5 mb-5">
          <Spinner animation="border" variant="info" />
        </div>
      )
    ) : (
      <NoDataFound
        setTaskview={taskViewRender}
        changeInForm={changeInForm}
        setAlertMessage={setAlertMessage}
        setShowAlertBox={setShowAlertBox}
        setChangeInForm={setChangeInForm}
        addtask="add task"
        headcontent="You have not Created any Project."
        bodycontent="create a task or project for your team to work on."
        btncontent="task"
        img={norecordsvg}
        refreshAllTracking={refreshAllTracking}
      />
    );
  }

  return (
    <>
      <Modal
        show={taskview === "taskview" && trackingItemData}
        onHide={() => setTaskview("AllTask")}
        size="xl"
        centered
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          {trackingItemData && (
            <TrackingView
              allWorkFlow={allWorkFlow}
              fetchFilteredTasks={fetchFilteredTasks}
              fileLoading={fileLoading}
              setTaskview={setTaskview}
              show={showTaskModal}
              setTaskFile={setTaskFile}
              setTaskFileType={setTaskFileType}
              taskfileType={taskfileType}
              item={trackingItemData}
              taskfileList={taskfileList}
              setTaskFileList={setTaskFileList}
              taskfile={taskfile}
              refreshfiles={refreshfiles}
              setShowView={(value) => setShowTaskModal(value)}
              allTaskTypes={allTaskTypes}
              allStatus={allFlowStatus}
              data={viewTaskData}
              setViewTaskData={setViewTaskData}
              setTrackingItemData={setTrackingItemData}
              showEditTask={showEditTask}
              setShowEditTask={setShowEditTask}
              updatedData={updatedData}
              setUpdatedData={setUpdatedData}
              history={taskHistory}
              setHistory={setHistory}
              setShowClone={setShowClone}
              selected_menu={selected_menu}
              setDeleteConfirmationShow={setDeleteConfirmationShow}
              fetchFileData={fetchFileData}
              deletePermission={deletePermission}
              editPermission={editPermission}
              allProjectsData={allProjects}
              allMemberes={allMembers}
              backlogsPermission={backlogsPermission}
              menu="mytask"
              testfile="testing popup MY TASK"
              handlePopUpclose={handlePopUpclose}
            />
          )}
        </Modal.Body>
      </Modal>

      <Modal
        show={taskview === "Clone" && clonetaskData?.title !== undefined}
        onHide={() => setTaskview("AllTask") && setShowClone(false)} // closes modal and goes back to table
        size="md"
        centered
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          {clonetaskData?.title !== undefined && taskview === "Clone" && (
            <Clone
              setTaskview={setTaskview}
              showClone={showClone}
              setShowClone={setShowClone}
              item={trackingItemData}
              allTrackingsList={allTrackingsList}
              setShowAlertBox={setShowAlertBox}
              setAlertMessage={setAlertMessage}
              clonetaskData={clonetaskData}
              setCloneTask={setCloneTask}
              backTo={"AllTask"}
              viewTaskData={viewTaskData}
            />
          )}
        </Modal.Body>
      </Modal>

      {myTrackingList?.length > 0 || columns ? (
        <>
          {showAlertBox && (
            <Alert
              variant="success"
              className="text-center alert-sucess mt-3 mb-1"
              dismissible
              closeVariant="white"
              onClick={(e) => setShowAlertBox(false)}
            >
              {alertMessage}
            </Alert>
          )}

          <ConfirmationBox
            heading="Are you sure to delete this ?"
            hidePopup={(e) => setDeleteConfirmationShow(false)}
            show={deleteConfirmationShow}
            confirmationResponse={deleteConfimrationHandler}
            setAlertMessage={setAlertMessage}
          />
          {taskview === "AllTask" || taskview === "Clone" ? (
            <>
              <CardView>
                <div
                  className="topContent"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    textAlign: "center",
                  }}
                >
                  <div className="view">
                    {/* <h2
                      onClick={(e) => setCardui("cardui")}
                      className={`Cardbtn ${
                        cardui === "cardui" ? "active" : ""
                      }`}
                    >
                      Card
                    </h2>
                    <span>|</span> */}
                    <h2
                      onClick={(e) => setCardui("List")}
                      className={`Listbtn ${cardui === "List" ? "active" : ""}`}
                    >
                      List
                    </h2>
                  </div>
                  {cardui === "cardui" ? (
                    createPermission && (
                      <div className="addTask">
                        <button
                          style={{
                            color: "#FFFFFF",
                            fontSize: "15px",
                            padding: "5px 12px",
                            backgroundColor: "#4EB6EE",
                            border: "none",
                            outline: "none",
                            borderRadius: "5px",
                          }}
                          onClick={(e) => {
                            setTaskview("addnew");
                            setFormType("new");
                            setChangeInForm(false);
                          }}
                        >
                          Add Task
                        </button>
                      </div>
                    )
                  ) : (
                    <></>
                  )}
                </div>
                {/* <Dynamicdata
                  selectedProject={selectedProject}
                  getSelectedOption={getSelectedOption}
                /> */}
              </CardView>
              {cardui === "cardui" ? (
                <div className="mt-3">
                  <TrackingModalView>
                    <TrackingListHeader
                      allStatuses={allStatuses}
                      allTrackingsList={myTrackingList}
                      searchValue={searchValue}
                      handleSearch={handleSearch}
                      userRole={user.rolename}
                      userRoleType={user.roletype}
                      refreshAllTracking={refreshAllTracking}
                      setLoading={(val) => setLoading(val)}
                      loading={loading}
                      trackingFilters={trackingFilters}
                      setTrackingFilters={setTrackingFilters}
                      trackingData={
                        selected_menu === "my_tasks" ? myTrackingList : []
                      }
                      cardView="Card"
                      setShowFormView={(val) => setShowFormView(val)}
                      setTaskview={setTaskview}
                      setFormType={(val) => setFormType(val)}
                      setChangeInForm={setChangeInForm}
                      showFilter={true}
                      setAllCheckTable={setAllCheckTable}
                      backlogsPermission={backlogsPermission}
                      fromDate={fromDate}
                      toDate={toDate}
                      setFromDate={setFromDate}
                      setToDate={setToDate}
                      handleStartDateChange={handleStartDateChange}
                      handleToDateChange={handleToDateChange}
                    />
                  </TrackingModalView>{" "}
                </div>
              ) : (
                <></>
              )}

              {allProjectsLoading ? (
                cardui !== "List" && (
                  <div className="text-center mt-5 mb-5">
                    <Spinner animation="border" variant="info" />
                  </div>
                )
              ) : (
                <></>
              )}

              {cardui === "cardui" ? (
                <>
                  <Cards
                    columns={columns}
                    setColumns={setColumns}
                    editSwitch={editSwitch}
                    isLoading={isLoading}
                    loading={loading}
                    firstData={project}
                    Work_Flow={Work_Flow}
                    showWorkFlow={showWorkFlow}
                    setTaskview={setTaskview}
                    setShowAlertBox={setShowAlertBox}
                    setAlertMessage={setAlertMessage}
                    key="cards"
                    assignedToMe={true}
                    trackingItemData={trackingItemData}
                    setTrackingItemData={setTrackingItemData}
                    fetchFileData={fetchFileData}
                    selected_menu={selected_menu}
                    setDeleteConfirmationShow={setDeleteConfirmationShow}
                    img={norecordsvg}
                    deletePermission={deletePermission}
                    createPermission={createPermission}
                  />

                  <ConfirmationBox
                    heading="Are you sure to delete this ?"
                    hidePopup={(e) => setDeleteConfirmationShow(false)}
                    show={deleteConfirmationShow}
                    confirmationResponse={deleteConfimrationHandler}
                    setAlertMessage={setAlertMessage}
                  />
                </>
              ) : (
                <>
                  <TrackingModalView>
                    <div className="trackingPage mt-1">
                      {/* Approval message alert styled like Backlogs page */}
                      {approvalMsg && (
                        <Alert
                          variant="success"
                          className="text-center alert-sucess alert mt-3 mb-1"
                          dismissible
                          closeVariant="white"
                          onClick={() => setApprovalMsg("")}
                          style={{
                            minHeight: "60px",
                            display: "flex",
                            alignItems: "center",
                            fontSize: "18px",
                          }}
                        >
                          {approvalMsg}
                        </Alert>
                      )}
                      <Tables
                        setDeleteConfirmationShow={setDeleteConfirmationShow}
                        selected_menu={selected_menu}
                        setTaskview={setTaskview}
                        setTrackingItemData={setTrackingItemData}
                        setShowEditTask={setShowEditTask}
                        deletePermission={deletePermission}
                        handleMoveCheckboxTable={handleMoveCheckboxTable}
                        allcheckTable={allcheckTable}
                        setAllCheckTable={setAllCheckTable}
                        onRowClick={handleRowClick}
                        columns={
                          <TrackingListColumns
                            handleSearch={handleSearch}
                            trackingSortings={trackingSortings}
                            setTrackingSorting={setTrackingSorting}
                            handleTasksHeaderCheckbox={
                              handleTasksHeaderCheckbox
                            }
                            setAllCheckTable={setAllCheckTable}
                            selectAllTasks={selectAllTasks}
                          />
                        }
                        startTrackingId={
                          searchValue
                            ? "none"
                            : selected_menu === "my_tasks"
                              ? startMyTrackingId
                              : "none"
                        }
                        data={
                          selected_menu === "my_tasks"
                            ? myTrackingData
                            : searchValue
                        }
                        showInfiniteScroll={true}
                        setHistory={setHistory}
                        header={
                          <TrackingListHeader
                            allStatuses={allStatuses}
                            setAlertMessage={setAlertMessage}
                            setShowAlertBox={setShowAlertBox}
                            allcheckTable={allcheckTable}
                            myTrackingList={myTrackingList}
                            searchValue={searchValue}
                            handleSearch={handleSearch}
                            userRole={user.rolename}
                            userRoleType={user.roletype}
                            allMembers={allMembers}
                            allProjects={allProjects}
                            createPermission={createPermission}
                            refreshAllTracking={refreshAllTracking}
                            setLoading={(val) => setLoading(val)}
                            loading={loading}
                            trackingFilters={trackingFilters}
                            setTrackingFilters={setTrackingFilters}
                            data={
                              selected_menu === "my_tasks"
                                ? myTrackingData
                                : searchValue
                            }
                            trackingData={
                              selected_menu === "my_tasks"
                                ? myTrackingData
                                : searchValue
                            }
                            menu={"my_tasks"}
                            setShowFormView={(val) => setShowFormView(val)}
                            setTaskview={setTaskview}
                            setFormType={(val) => setFormType(val)}
                            setChangeInForm={setChangeInForm}
                            showFilter={showFilter}
                            backlogsPermission={backlogsPermission}
                          />
                        }
                        notfound={"No Trackings Found"}
                        loading={
                          selected_menu === "all_tasks"
                            ? !fetchedAllTrackings
                            : !fetchedMyTrackings
                        }
                        // Pass approval message handler to Tables
                        setApprovalMsg={setApprovalMsg}
                      />
                      {paginationLoading && (
                        <div className="text-center my-4">
                          <Spinner animation="border" variant="info" />
                          <p className="mt-2" style={{ color: "#666" }}>
                            Loading more tasks...
                          </p>
                        </div>
                      )}
                    </div>
                  </TrackingModalView>

                  <ConfirmationBox
                    heading="Are you sure to delete this ?"
                    hidePopup={(e) => setDeleteConfirmationShow(false)}
                    show={deleteConfirmationShow}
                    confirmationResponse={deleteConfimrationHandler}
                  />
                </>
              )}
            </>
          ) : taskview === "taskview" ? (
            <>
              {trackingItemData.title ? (
                <>
                  {/* <TrackingView
                    fileLoading={fileLoading}
                    setTaskview={setTaskview}
                    show={showView}
                    setTaskFile={setTaskFile}
                    setTaskFileType={setTaskFileType}
                    taskfileType={taskfileType}
                    item={trackingItemData}
                    taskfileList={taskfileList}
                    setTaskFileList={setTaskFileList}
                    taskfile={taskfile}
                    refreshfiles={refreshfiles}
                    setShowView={(value) => setShowView(value)}
                    allTaskTypes={allTaskTypes}
                    allStatus={allFlowStatus}
                    data={viewTaskData}
                    setViewTaskData={setViewTaskData}
                    setTrackingItemData={setTrackingItemData}
                    showEditTask={showEditTask}
                    setShowEditTask={setShowEditTask}
                    updatedData={updatedData}
                    setUpdatedData={setUpdatedData}
                    history={taskHistory}
                    setHistory={setHistory}
                    setShowClone={setShowClone}
                    selected_menu={selected_menu}
                    setDeleteConfirmationShow={setDeleteConfirmationShow}
                    fetchFileData={fetchFileData}
                    deletePermission={deletePermission}
                    editPermission={editPermission}
                    allProjectsData={allProjects}
                    allMemberes={allMembers}
                    backlogsPermission={backlogsPermission}
                    menu='mytask'
                  /> */}
                  {/* {clonetaskData.title !== undefined && taskview === "Clone" ? (
                    <Clone
                      setTaskview={setTaskview}
                      showClone={showClone}
                      setShowClone={setShowClone}
                      item={trackingItemData}
                      allTrackingsList={allTrackingsList}
                      setShowAlertBox={setShowAlertBox}
                      setAlertMessage={setAlertMessage}
                      clonetaskData={clonetaskData}
                      setCloneTask={setCloneTask}
                      backTo={"AllTask"}
                      viewTaskData={viewTaskData}
                    />
                  ) : (
                    <></>
                  )} */}
                </>
              ) : (
                <></>
              )}
            </>
          ) : null}
        </>
      ) : (
        <>
          <CardView>
            <div
              className="topContent"
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                textAlign: "center",
              }}
            >
              <div className="view">
                <h2
                  onClick={(e) => setCardui("cardui")}
                  className={`Cardbtn ${cardui === "cardui" ? "active" : ""}`}
                >
                  Card
                </h2>
                <span>|</span>
                <h2
                  onClick={(e) => setCardui("List")}
                  className={`Listbtn ${cardui === "List" ? "active" : ""}`}
                >
                  List
                </h2>
              </div>
              {cardui === "cardui" ? (
                <div className="addTask">
                  <button
                    style={{
                      color: "#FFFFFF",
                      fontSize: "15px",
                      padding: "5px 12px",
                      backgroundColor: "#4EB6EE",
                      border: "none",
                      outline: "none",
                      borderRadius: "5px",
                    }}
                    onClick={(e) => {
                      setTaskview("addnew");
                      setFormType("new");
                      setChangeInForm(false);
                    }}
                  >
                    Add Task
                  </button>
                </div>
              ) : (
                <></>
              )}
            </div>
            {/* <Dynamicdata selectedProject={selectedProject} getSelectedOption={getSelectedOption} />  */}
          </CardView>
        </>
      )}
    </>
  );
}
